
<section :class="['notifications-panel', { open }]">
  <align class="header" flex>
    <h5 class="secondary-font">
      Notifications
    </h5>

    <align small-gap>
      <dropdown
        v-if="!showEmptyState"
        align="right"
        :active="menuOpen"
        @close="menuOpen = false"
      >
        <icon-button
          icon="more_vert"
          @click="menuOpen = !menuOpen"
        />

        <template #menu>
          <dropdown-menu
            :options="menuOptions"
            @select="handleSelect"
          />
        </template>
      </dropdown>

      <icon-button
        icon="close"
        @click="$store.commit('SET_NOTIFICATIONS_OPEN', false)"
      />
    </align>
  </align>

  <empty-state
    v-if="showEmptyState"
    icon="notifications_off"
    description="You have no notifications at the moment"
  />

  <template v-else-if="loaded">
    <div
      v-for="notification in notifications"
      :key="notification.id"
      class="item"
    >
      <notification-item
        :notification="notification"
        @read="markNotficationAsRead"
      />
    </div>
  </template>

  <spinner v-else />
</section>
